import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, DEFAULT_LANGUAGE } from '@/config/languages';
import type { LanguageCode } from '@/config/languages';

// Keeps `<html lang>` and `<html dir>` in sync with the active language.
// RTL only applies to Arabic per IV (UI Behavior §7.7).
export function useDirection() {
  const { i18n } = useTranslation();
  const code = (i18n.resolvedLanguage ?? i18n.language ?? DEFAULT_LANGUAGE) as LanguageCode;

  useEffect(() => {
    const lang = LANGUAGES.find((l) => l.code === code) ?? LANGUAGES[0];
    document.documentElement.setAttribute('lang', lang.code);
    document.documentElement.setAttribute('dir', lang.dir);
  }, [code]);
}
